import './Home.css';

const Quote = () => (
  <>
    <h3 className="heading">Quote</h3>
    <p className="info">
      As far as the laws of mathematics refer to reality, they are not certain,
      and as far as they are certain,
      they do not refer to reality.
      <strong> ~ Albert Einstein</strong>
    </p>
  </>
);

export default Quote;
